import { setStore, getStore, removeStore, getQueryObj } from '@/common/utils';
import permission from './permission';
import config from '@/config';

class User {
  constructor(cacheName = '') {
    this.cacheName = cacheName || 'userInfo';
    // 登录信息字段
    this.loginArr = [
      'storeId',
      'login_token',
      'channel_user_id',
      'user_name',
      'roleId',
      'user_tel'
    ];
    this.initUserInfo();
    // 不需要登录的路由
    this.whiteList = config.loginWhiteList;
  }
  initUserInfo() {
    this.clearUserInfo();
    let queryStr = location.search.split('?')[1] || location.hash.split('?')[1];
    if (process.env.VUE_APP_BUILD_MODE === 'development') {
      // storeId=53006; storeId=51490
      queryStr =
        // 'login_token=42667514040b7ff18077e3191b28d98d&storeId=53006&channel_user_id=2351&user_name=林国威&roleId=75&user_tel=13590491852';
        // 'login_token=7686751242871d82aa420e198bf18e53&storeId=669&channel_user_id=2195&user_name=林定锋&roleId=75&user_tel=18084621629'; // 开发
        'storeId=1201769&login_token=78013110764177564bbc8cfac89aa833::78013::1::1076417::75&channel_user_id=1076417&user_name=佛山测试&user_id=78013&roleId=75&user_tel=13536942223&merchant_id=220469807'; // 测试
      // 'login_token=232875121365cf775a8e91f6bca7ee6f&storeId=669&channel_user_id=2136&user_name=戴晨晖&roleId=75&user_tel=15877778888'; // 测试
      // 'login_token=2328751213640a9021d6ba996d0ff17e&storeId=54033&channel_user_id=4045&user_name=Brook&roleId=75&user_tel=15877778888'; // 鲍鲁涛测试
      // 'login_token=42557514031ca824b54d98b2bf0b7b53&storeId=669&channel_user_id=4031&user_name=test&roleId=75&user_tel=15877778888'; // 测试-邵然测试
      // 'login_token=23287512136d86f244c4fd459bbc27f1&storeId=54029&channel_user_id=917&user_name=test&roleId=75&user_tel=15877778888'; // 测试-国梁测试
      // 'login_token=992357511062581c5767b5a89d453924&storeId=50824&channel_user_id=109236&user_name=戴晨晖&roleId=75&user_tel=15877778888'; // 线上
    }
    let info = '';
    if (queryStr) {
      info = getQueryObj(null, queryStr);
    }
    const userInfoObj = {};
    for (let i in info) {
      if (Object.prototype.hasOwnProperty.call(info, i)) {
        const item = info[i];
        if (this.loginArr.find(el => i === el)) {
          userInfoObj[i] = item;
        }
      }
    }
    info && this.setUserInfo(userInfoObj);
  }
  /**
   * 获取url中传递的登录态必要信息
   */
  getLoginInfo() {
    const info = getStore(this.cacheName);
    const obj = {};
    this.loginArr.forEach(item => {
      obj[item] = info[item];
    });
    return obj;
  }
  /**
   * 获取用户信息
   * @param {*} key
   */
  getUserInfo(key) {
    let info = getStore(this.cacheName) || {};
    if (key) {
      return info[key] || '';
    }
    return info || '';
  }
  /**
   * 获取用户amc信息
   */
  getAmcInfo() {
    let info = getStore(this.cacheName);
    const data = {
      amcUserId: info.amc_id,
      amcUserName: info.amc_name,
      amcRealName: info.real_name
    };
    return data || {};
  }
  setUserInfo(userInfo) {
    const info = Object.assign(this.getUserInfo() || {}, userInfo);
    setStore(this.cacheName, info);
  }
  clearUserInfo() {
    removeStore(this.cacheName);
  }
  async checkUserInfo(path) {
    // 白名单直接通过检查
    const isWhite = this.whiteList.find(item => item === path);
    if (isWhite) return true;
    // 校验登录态字段
    const userInfo = this.getUserInfo();
    const flag = !this.loginArr.some(el => !userInfo[el]);
    console.log(`登录态${flag}`);
    if (!flag) return flag;
    // 校验权限
    const permissionFlag = await permission.check();
    console.log(`角色权限${permissionFlag}`);
    if (!permissionFlag) return permissionFlag;
    return true;
  }
}

export default new User();
